var apiPath = "https://recruiting.paylocity.com/recruiting/v2/api/feed/jobs/dec20654-3361-4002-8aaa-d4e90d12c77c";

export async function getJobs() {

    var jobAPIResult = await fetch(apiPath)
    var _ = jobAPIResult.json()
    return _
}

const sampleJobAPIResult = {
    "displayName": "Sample Company",
    "vidGridId": "xttoeIL1ez02",
    "showVideo": true,
    "jobs": [
        {
            "vidGridId": "xttoeIL0ezO1",
            "showVideo": true,
            "jobId": 13784,
            "title": "Javascript Dev",
            "companyName": "Company A",
            "applyUrl": "https://recruiting.paylocity.com/recruiting/Jobs/Apply/13784/Automation-Inc/Javascript-Dev",
            "createdUtc": "2019-08-07T17:53:20.817",
            "publishedDate": "2019-08-07T17:53:36.787",
            "description": "<p>Javascript Dev</p>",
            "displayUrl": "https://recruiting.paylocity.com/recruiting/Jobs/Details/13784/Automation-Inc/Javascript-Dev",
            "jobLocation": {
                "name": "Test Office",
                "address": "2850 N. Wilke Road",
                "address2": null,
                "city": "Arlington Heights",
                "state": "IL",
                "zip": "60004",
                "metro": "Chicago",
                "locationDisplayName": "Test Office"
            },
            "jobCode": "",
            "listUrl": "https://recruiting.paylocity.com/recruiting/Jobs/List/96/Automation-Inc",
            "requirements": "<p>Javascript Dev</p>",
            "salaryDescription": "$75,000",
            "hiringDepartment": "Development",
            "jobTypes": "fulltime, parttime, temporary",
            "jobTypesArray": [
                "Full-time",
                "Part-time",
                "Temporary"
            ]
        },
        {
            "vidGridId": "xttoeIL0ezO1",
            "showVideo": true,
            "jobId": 13785,
            "title": "Javascript Dev 2",
            "companyName": "Company B",
            "applyUrl": "https://recruiting.paylocity.com/recruiting/Jobs/Apply/13784/Automation-Inc/Javascript-Dev",
            "createdUtc": "2019-08-07T17:53:20.817",
            "publishedDate": "2019-08-07T17:53:36.787",
            "description": "<p>Javascript Dev</p>",
            "displayUrl": "https://recruiting.paylocity.com/recruiting/Jobs/Details/13784/Automation-Inc/Javascript-Dev",
            "jobLocation": {
                "name": "Test Office",
                "address": "2850 N. Wilke Road",
                "address2": null,
                "city": "Arlington Heights",
                "state": "IL",
                "zip": "60004",
                "metro": "Chicago",
                "locationDisplayName": "Test Office"
            },
            "jobCode": "",
            "listUrl": "https://recruiting.paylocity.com/recruiting/Jobs/List/96/Automation-Inc",
            "requirements": "<p>Javascript Dev</p>",
            "salaryDescription": "$75,000",
            "hiringDepartment": "Development",
            "jobTypes": "fulltime, parttime, temporary",
            "jobTypesArray": [
                "Full-time",
                "Part-time",
                "Temporary"
            ]
        }
    ]
}